import {
  ChangeDetectorRef,
  DestroyRef,
  Directive,
  OnInit,
  TemplateRef,
  ViewContainerRef,
  inject,
  input,
  InputSignal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PermissionService } from '@lyceo/shared/permissions/data-access';

@Directive({
  selector: '[lyceoHasPermission]',
})
export class HasPermissionDirective implements OnInit {
  private readonly templateRef: TemplateRef<unknown> =
    inject<TemplateRef<unknown>>(TemplateRef);
  private readonly permissionService: PermissionService =
    inject(PermissionService);
  private readonly destroyRef: DestroyRef = inject(DestroyRef);
  private readonly viewContainer: ViewContainerRef = inject(ViewContainerRef);
  private readonly changeDetectorRef: ChangeDetectorRef =
    inject(ChangeDetectorRef);

  public readonly lyceoHasPermission: InputSignal<string | string[]> = input<
    string | string[]
  >([]);
  public readonly lyceoHasPermissionInverse: InputSignal<boolean> =
    input<boolean>(false);

  public ngOnInit(): void {
    this.permissionService
      .hasPermission(this.lyceoHasPermission())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((granted) => {
        this.viewContainer.clear();

        if (this.lyceoHasPermissionInverse()) {
          granted = !granted;
        }

        if (granted) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        }

        this.changeDetectorRef.detectChanges();
      });
  }
}
